function basePath() {
  return window.configs.PDF_HOST + '/api/';
}

// NOTE: Remove ignoreResponse from every request in this file. If this causes issues, we need to figure out alternative.
export async function getTaxInvoicePDF(taxInvoiceObj) {
  const response = await fetch(basePath() + 'pdf/tax-invoice', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...taxInvoiceObj,
    }),
  });

  return await response.blob();
}

export async function getRatePlansPDF(payload) {
  const response = await fetch(basePath() + 'pdf/rate-plans', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  return await response.blob();
}

export async function getTaxesAndFeesPDF(payload) {
  const response = await fetch(basePath() + 'pdf/taxes-and-fees', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  return await response.blob();
}

export async function getCommissionStatementPDF(payload) {
  const response = await fetch(basePath() + 'pdf/commission-report', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  return await response.blob();
}

export async function htmlToPdf(html) {
  const response = await fetch(`${basePath()}pdf/html-printer`, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain; charset=UTF-8' },
    body: html,
  });

  return await response.blob();
}
